export const LOW_HIGH = "low/high";

export const IN = "in";
export const NOT_IN = "notin";
